module.exports = __webpack_public_path__ + "static/media/paypal.ff3ad0b4.svg";